<template>
  <div>
<b-container>
    login
    <form @submit.prevent="pressed">

        <div class='login'>
            <input type='email' placeholder='email' v-model="email">
        </div>
                <div class='password'>
            <input type='password' placeholder='password' v-model="password">
        </div>
        <button>Login</button>
    </form>
<div class='error' v-if='error'>{{error.message}}</div>
</b-container>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data () {
    return {
      email: '',
      password: '',
      error: ''
    }
  },
  methods: {
    async pressed () {
      try {
        const val = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
        console.log(val)
        this.$router.replace({ name: 'cluep' })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Righteous");

h1 {
  font-family: "Righteous", cursive;
  font-size: 100px;
}
h2 {
  font-size: 27px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.topmargin {
  padding-top: 100px;
}
.no-margin {
  padding-left: 0px;
  padding-right: 0px;
}
.link {
  color: #000000;
  text-decoration: underline;
  text-decoration-color: #00cc99;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
  transition: background-size 0.4s ease;
  background: linear-gradient(to bottom, transparent 62%, #00cc99 0) center
    center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
  font-weight: 600;
  font-size: 20px !important;
}
.link:hover {
  background-size: 100% 100%;
  color: #000000;
}

.link2 {
  color: #000000;
  text-decoration: underline;
  text-decoration-color: #00cc99;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
  transition: background-size 0.4s ease;
  background: linear-gradient(to bottom, transparent 62%, #00cc99 0) center
    center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
  font-weight: 600;
}
.link2:hover {
  background-size: 100% 100%;
  color: #000000;
}
.card-text {
  color: black;
}
.margin-on-card {
  margin-bottom: 20px;
  margin-top: 20px;
}

.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.hvr-grow:hover,
.hvr-grow:focus,
.hvr-grow:active {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.general-padding {
  padding: 10px;
}
.card-size {
  width: 100%;
}
.middle-margin {
  padding-left: 160px;
  padding-right: 160px;
}
.heading-padding {
  padding-top: 40px;
  padding-bottom: 10px;
}

/* On screens that are 992px or less, set the background color to blue */
@media screen and (max-width: 992px) {
  h1 {
    font-size: 100px;
  }
  .middle-margin {
    padding-left: 40px;
    padding-right: 40px;
  }
  h2 {
    font-size: 23px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
  h1 {
    font-size: 60px;
  }
  h2 {
    font-size: 21px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  h4 {
    font-size: 20px;
  }
  .heading-padding {
    padding-left: 10px;
    padding-right: 10px;
  }
  .middle-margin {
    padding-left: 10px;
    padding-right: 10px;
  }
  .link {
    font-size: 16px !important;
  }
}

@media screen and (max-width: 400px) {
  h1 {
    font-size: 63px;
  }
  .heading-padding {
    padding-left: 5px;
    padding-right: 5px;
  }
  .middle-margin {
    padding-left: 10px;
    padding-right: 10px;
  }
  .link {
    font-size: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue